const countly = {
    savePageCountly() {
        window.Countly.q.push(['track_pageview', window.location.pathname + window.location.hash])
    }
}

export default countly